export default __webpack_public_path__ + "static/media/content_copy.668faa1c.svg";